import { render, staticRenderFns } from "./FirmItemUpdateModal.vue?vue&type=template&id=7fe04d3d&"
import script from "./FirmItemUpdateModal.vue?vue&type=script&lang=ts&"
export * from "./FirmItemUpdateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports